module.exports = __webpack_public_path__ + "img/06.a4282f89.jpg";